import { ReactNode, createContext, useEffect, useMemo, useState } from 'react';

export const FONT_SIZE_LIST = [14, 16, 18, 20, 24] as const;
export const INITIAL_FONT_SIZE_INDEX = 1;
export const FONT_SIZE_INDEX_STORAGE_KEY = 'worker-font-size-index';

export interface FontSizeContextValue {
  fontSize: number;
  fontSizeIndex: number;
  fontSizeList: typeof FONT_SIZE_LIST;
  update: (fontSizeIndex: number) => void;
}

export const FontSizeContext = createContext<FontSizeContextValue>({
  fontSize: FONT_SIZE_LIST[INITIAL_FONT_SIZE_INDEX],
  fontSizeIndex: INITIAL_FONT_SIZE_INDEX,
  fontSizeList: FONT_SIZE_LIST,
  update: () => {},
});

interface FontSizeProviderProps {
  children: ReactNode;
}

export const FontSizeProvider = (props: FontSizeProviderProps) => {
  const { children } = props;
  const [fontSizeIndex, setFontSizeIndex] = useState(INITIAL_FONT_SIZE_INDEX);

  const fontSize = useMemo(() => {
    return FONT_SIZE_LIST[fontSizeIndex];
  }, [fontSizeIndex]);

  useEffect(() => {
    const storedFontSizeIndex = localStorage.getItem(FONT_SIZE_INDEX_STORAGE_KEY);
    if (storedFontSizeIndex) {
      setFontSizeIndex(parseInt(storedFontSizeIndex));
    }
  }, []);

  const update = (fontSizeIndex: number) => {
    setFontSizeIndex(fontSizeIndex);
    localStorage.setItem(FONT_SIZE_INDEX_STORAGE_KEY, fontSizeIndex.toString());
  };

  /**
   * 돔에 폰트 사이즈를 적용한다.
   */
  useEffect(() => {
    const base = 16;
    const ratio = fontSize / base;
    document.body.style.setProperty('--data-font-size', fontSize + 'px');
    document.body.style.setProperty('--data-font-scale', ratio.toString());
  }, [fontSize]);

  return (
    <FontSizeContext.Provider
      value={{ fontSize, fontSizeIndex, fontSizeList: FONT_SIZE_LIST, update }}
    >
      {children}
    </FontSizeContext.Provider>
  );
};
